// src/app/modules/commissionConfigs/CommissionConfigsListPage.tsx
import React from 'react'
import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { CommissionConfigsList } from './CommissionConfigsList'

const CommissionConfigsListPage = () => (
  <Routes>
    {/* Ruta padre vacía que renderiza el Outlet */}
    <Route path="" element={<Outlet />}>
      {/* Index route: path === "" */}
      <Route
        index
        element={
          <>
            <PageTitle>Listado de comisiones por cliente</PageTitle>
            <CommissionConfigsList />
          </>
        }
      />
      {/* Aquí podrías añadir más sub‐rutas si las necesitas */}
    </Route>

    {/* Cualquier otra ruta dentro de este módulo redirige al index */}
    <Route path="*" element={<Navigate to="" replace />} />
  </Routes>
)

export default CommissionConfigsListPage
